import classNames from 'classnames';
import { ReactNode } from 'react';
import InfoIcon from '@/shared/assets/icons/info-circle.svg';
import s from './Alert.module.scss';

interface AlertProps {
  className?: string;
  icon?: ReactNode;
  children: ReactNode;
}

export const Alert = ({ className, icon, children }: AlertProps) => {
  return (
    <div className={classNames(s.root, className)}>
      {icon || <InfoIcon className={s.icon} />}
      <span className={s.text}>{children}</span>
    </div>
  );
};
